import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GET_MODEL_TYPES, GetModelTypesSuccess, GetModelTypes, GET_TIRE_SIZES, GetTireSizesSuccess, GetTireSizes, GET_PROVIDER_LOCATIONS, GetProviderLocations, GetProviderLocationsSuccess } from '../actions/loaner-wheel-inventory.action';
import { withLatestFrom, map, filter, exhaustMap, switchMap, catchError } from 'rxjs/operators';
import { IncrementLoaderCount, DecrementLoaderCount } from 'app/shared/store/actions/loader.actions';
import { PushError } from 'app/shared/store/actions/error.actions';
import { LoanWheelInventoryService } from 'app/profile/services/loaner-wheel-inventory.service';
import { SelectModelTypes, SelectTireSizes, SelectProviderLocations } from '../selectors/loaner-wheel-inventory.selector';
import { LoanerWheelInventoryState } from '../state/loaner-wheel-inventory.state';
import { SelectEventData } from '../selectors/event.selector';

@Injectable()
export class LoanerWheelInventoryEffects {
    constructor(
        private actions$: Actions,
        private store: Store<LoanerWheelInventoryState>,
        private inventoryService: LoanWheelInventoryService) { }

    @Effect()
    getModelTypes$ = this.actions$
        .pipe(
            ofType(GET_MODEL_TYPES),
            map((action: GetModelTypes) => action),
            withLatestFrom(this.store.select(SelectModelTypes)),
            filter(([action, state]) => state == null),
            exhaustMap(() => {
                this.store.dispatch(new IncrementLoaderCount());
                return this.inventoryService.getModelType()
                    .pipe(
                        switchMap((types) => {
                            return [
                                new GetModelTypesSuccess(types),
                                new DecrementLoaderCount()
                            ]
                        }),
                        catchError((err) => {
                            return [
                                new PushError(err),
                                new DecrementLoaderCount()
                            ]
                        })
                    )
            })
        );

    @Effect()
    getTireSizes$ = this.actions$
        .pipe(
            ofType(GET_TIRE_SIZES),
            map((action: GetTireSizes) => action),
            withLatestFrom(this.store.select(SelectTireSizes)),
            filter(([action, state]) => state == null),
            exhaustMap(() => {
                this.store.dispatch(new IncrementLoaderCount());
                return this.inventoryService.getTireSize()
                    .pipe(
                        switchMap((types) => {
                            return [
                                new GetTireSizesSuccess(types),
                                new DecrementLoaderCount()
                            ]
                        }),
                        catchError((err) => {
                            return [
                                new PushError(err),
                                new DecrementLoaderCount()
                            ]
                        })
                    )
            })
        );

    @Effect()
    getProviderLocations$ = this.actions$
        .pipe(
            ofType(GET_PROVIDER_LOCATIONS),
            map((action: GetProviderLocations) => action),
            withLatestFrom(this.store.select(SelectProviderLocations)),
            filter(([action, state]) => action.forceReload || state == null),
            exhaustMap(([action]) => {
                this.store.dispatch(new IncrementLoaderCount());
                return this.inventoryService.getProviderLocations(action.payload)
                    .pipe(
                        switchMap((locations) => {
                            return [
                                new GetProviderLocationsSuccess(locations),
                                new DecrementLoaderCount()
                            ]
                        }),
                        catchError((err) => {
                            return [
                                new PushError(err),
                                new DecrementLoaderCount()
                            ]
                        })
                    )
            })
        );
}